import React, { useRef, useState } from 'react';
import api from '../../../utils/api';
import { patchCachedProfile } from '../../pro/profileCache';
import { SKIN_RETRO, SKIN_TACTICAL, parseSkin } from '../../../styles/skin';
import { useSkin } from '../../../styles/SkinProvider';
import { ProfilePanel } from './ProfilePanel';

export const APPEARANCE_COPY = {
  title: 'APPEARANCE',
  onLabel: 'TACTICAL',
  offLabel: 'CLASSIC (RETRO)',
  onNote: 'Dark field palette, squared edges, Oswald headings. This is the default.',
  offNote: 'The original Yona look — sand ground, rust accent, Bevan headings.',
  footnote: 'SAVED TO YOUR PROFILE · APPLIES EVERYWHERE YOU SIGN IN',
};

export function AppearancePanel() {
  const { skin, setSkin } = useSkin();
  const tacticalOn = parseSkin(skin) === SKIN_TACTICAL;
  const [error, setError] = useState('');
  const ticketRef = useRef(0);

  const persistSkin = async (next) => {
    const previous = parseSkin(skin);
    setError('');
    setSkin(next);
    const ticket = ++ticketRef.current;
    try {
      const resp = await api.patch('/profiles/me/', { skin: next });
      if (ticket !== ticketRef.current) return;
      if (resp?.data) patchCachedProfile(resp.data);
    } catch (err) {
      if (ticket !== ticketRef.current) return;
      setSkin(previous);
      setError(err?.response?.data?.error || 'Failed to save appearance');
    }
  };

  const toggle = () => {
    persistSkin(tacticalOn ? SKIN_RETRO : SKIN_TACTICAL);
  };

  return (
    <ProfilePanel title={APPEARANCE_COPY.title} bodyClassName="y-profile-panel__body--flush-list">
      <div className="y-appearance" data-testid="profile-appearance">
        <div className="y-appearance__row">
          <div className="y-appearance__copy">
            <p className="y-appearance__label">
              {tacticalOn ? APPEARANCE_COPY.onLabel : APPEARANCE_COPY.offLabel}
            </p>
            <p className="y-appearance__note">
              {tacticalOn ? APPEARANCE_COPY.onNote : APPEARANCE_COPY.offNote}
            </p>
          </div>
          <button
            type="button"
            role="switch"
            aria-checked={tacticalOn}
            aria-label="Tactical appearance"
            className={`y-appearance-switch${tacticalOn ? ' is-on' : ''}`}
            onClick={toggle}
          >
            <span className="y-appearance-switch__knob" aria-hidden="true" />
          </button>
        </div>
        <p className="y-appearance__footnote">{APPEARANCE_COPY.footnote}</p>
        {error ? <div className="y-profile-msg y-profile-msg--error">{error}</div> : null}
      </div>
    </ProfilePanel>
  );
}
